module.exports = __webpack_public_path__ + "static/media/handphone.a8bd3bc9.svg";